import { Component, EventEmitter, forwardRef, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { noop } from 'rxjs';
import { TextInputComponent } from '../text-input/text-input.component';
import { FocusableControlValueAccessor } from '../FocusableControlValueAccessor';

@Component({
  selector: 'opac-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PasswordInputComponent),
      multi: true,
    }
  ]
})
export class PasswordInputComponent implements FocusableControlValueAccessor {
  /**
   * Sets input disabled state
   */
  @Input() set disabled(value: boolean) {
    this.setDisabledState(value);
  };
  /**
   * Input id for label join.
   * Defaults to random string.
   */
  @Input() id: string = Math.random().toString(16).substring(2);
  /**
   * Determines if input is invalid.
   */
  @Input() invalid: boolean = false;
  /**
   * Determines input name attribute.
   */
  @Input() name: string = '';
  /**
   * Determines input readonly status.
   */
  @Input() readonly: boolean = false;
  /**
   * Sets required state for input.
   * This prop won't validate, it is just for accessibility reasons.
   */
  @Input() required: boolean = false;
  /**
   * Emits when input is blurred.
   */
  @Output() blur= new EventEmitter<Event>();

  @ViewChild('passwordEl') passwordEl: TextInputComponent;

  type: 'text' | 'password' = 'password';

  onChange: (value: string) => void = noop;
  onTouch: () => void = noop;

  isDisabled = false;
  value = '';

  handleOnTouch(event: Event) {
    this.onTouch();
    this.blur.emit(event);
  }

  handleIconClick() {
    if (this.type === 'password') {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  focus(): void {
    this.passwordEl.focus();
  }

  writeValue(obj: string): void {
    this.value = obj;
  }
}
